import React from 'react';
import { observable, action, runInAction } from 'mobx';
import { PAGE_SIZE_DEFAULT } from '../constants/appConstant';
import reportAPI from '../apis/reportAPI'
import alertMessage from '../utils/alertMessage'
import { Typography } from 'antd';
const { Text } = Typography;

export default class ReportStore {
  constructor(rootStore) {
      this.rootStore = rootStore;
  }
  @observable isFetching = false;
  @observable pageSize = PAGE_SIZE_DEFAULT;
  @observable pageSizeOrder = PAGE_SIZE_DEFAULT;
  @observable pageNo = 1;
  @observable pageNoOrder = 1;
  @observable currIndex = 0
  @observable currIndexOrder = 0
  @observable itemCount = 0;
  @observable itemCountOrder = 0;

  /*SearchResult start*/
  @observable searchItemEBilling = {}
  @observable eBillingList = []
  @action
  async onSearchEBillingAction(params,pageNo,pageSize) {
    this.isFetching = true;
    this.pageNo = pageNo;
    this.pageSize = pageSize;
    this.itemCount = 0
    try {
      this.searchItemEBilling = params;
      this.eBillingList = [];
      const response = await reportAPI.searchEBillingAction(params,pageNo,pageSize);
      runInAction(() => {
        this.isFetching = false;
        if (response.data.code === 200) {
          this.eBillingList = response.data.data?.content || []
          this.pageNo = pageNo
          this.itemCount = response.data.data?.totalElements
        }else if(response.data.code === 400 && response.data.messageEn.indexOf("timed out") !== -1){
          alertMessage.error('Failed！Timed Out!')
        }else {
          alertMessage.error('Failed！' + response.data.messageEn +'')
        }
      })
    } catch (err) {
      alertMessage.error(err.message);
      runInAction(() => {
        this.isFetching = false;
      });
    }
  }
  /*SearchResult end*/
  @action
  onChangeEBillingList(value){
    this.eBillingList=value
    this.itemCount=0
  }
  @action
  async onResendAction(params){
    this.isFetching = true
    try {
      const response = await reportAPI.resendAction(params)
      runInAction(() => {
        this.isFetching = false;
        if (response.data.code === 200) {
          const params=[]
          response.data.data.data.map(item=> {return params.push({
            code:item.code,
            requestId:item.requestId,
            message:item.message
          })})
          alertMessage.success({
            content: <div style={{marginTop:'-20px', background: 'white', position: 'relative', zIndex:100}}>
              {params.map(item => <p><Text style={{paddingRight:10}}>{item.requestId}</Text><Text type={item.code===200?"success":'danger'}>{item.message}</Text></p>)}
            </div>,
          })
          this.onSearchEBillingAction(this.searchItemEBilling,this.pageNo,this.pageSize)
        }else {
          alertMessage.error('Resend Failed！' + response.data?.messageEn +'')
        }
      })
      return response
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false;
      });
    }
  }
  @observable selectedRowKeys=[]
  @observable selectedRows=[]
  @action
  onChangeSelectedRowKeys(selectedRowKeys,selectedRows){
    this.selectedRowKeys=selectedRowKeys
    this.selectedRows=selectedRows
  }
  @action
  onChangePageNumAction(pageNo, pageSize) {
    if (this.pageNo === pageNo && (!pageSize || this.pageSize === pageSize)) {
      return;
    }
    runInAction(() => {
      this.pageNo = pageNo;
      this.pageSize = pageSize;
    });
    this.onSearchEBillingAction(this.searchItemEBilling,this.pageNo,this.pageSize)
  }


  /*SearchResult start*/
  @observable searchItemOrder = {}
  @observable orderList = []
  @action
  async onSearchOrderAction(params,pageNo,pageSize) {
    this.isFetching = true;
    this.pageNoOrder = pageNo;
    this.pageSizeOrder = pageSize;
    this.itemCountOrder = 0
    try {
      this.searchItemOrder = params;
      this.orderList = [];
      const response = await reportAPI.searchOrderAction(params,pageNo,pageSize);
      runInAction(() => {
        this.isFetching = false;
        if (response.data.code === 200) {
          this.orderList = response.data.data?.content || []
          this.itemCountOrder = response.data.data?.totalElements
        }else if(response.data.code === 400 && response.data.messageEn.indexOf("timed out") !== -1){
          alertMessage.error('Failed！Timed Out!')
        } else {
          alertMessage.error('Failed！' + response.data.messageEn +'')
        }
      })
    } catch (err) {
      alertMessage.error(err.message);
      runInAction(() => {
        this.isFetching = false;
      });
    }
  }
  @action
  onChangeOrderList(value){
    this.orderList=value
    this.itemCountOrder=0
  }
  @action
  onChangeOrderPageNumAction(pageNo, pageSize) {
    if (this.pageNoOrder === pageNo && (!pageSize || this.pageSizeOrder === pageSize)) {
      return;
    }
    runInAction(() => {
      this.pageNoOrder = pageNo;
      this.pageSizeOrder = pageSize;
    });
    this.onSearchOrderAction(this.searchItemOrder,this.pageNoOrder,this.pageSizeOrder)
  }
}
